import React from 'react';
import spinner from 'src/assets/icons/spinner.svg';
import '../style.scss';

const AbsoluteSpinner = ({ height }: { height: number }) => {
  return (
    <div className='spinner_box'>
      <img src={spinner} alt='' height={height} width='auto' />
    </div>
  );
};

export default React.memo(AbsoluteSpinner);
